export const WALLET_SETTLEMENT_LIST_REQUEST = 'WALLET_SETTLEMENT_LIST_REQUEST';

export const SETTLEMENT_LIST_APPROVAL_REQUEST = 'SETTLEMENT_LIST_APPROVAL_REQUEST';
